(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/config.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/config.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.models = svs.matchen.models || {};

  svs.matchen.models.Config = Backbone.Model.extend({
    TYPE_SOCCER: 1,

    defaults: {
      tabs: [],
      links: [],
      hotDraws: [],
      backgroundImageURL: [],
      heatmapLimit: {
        min: 0,
        max: 17,
        startMin: 0,
        startMax: 11
      },
      noOpenDrawsTxt:
        'Inga öppna omgångar för tillfället. <br />Återkom om en kort stund.'
    },

    initialize: function() {
      var hasNoOpenDrawsTxt;

      if (svs.utils.ns.isNamespace('svs.matchen.data.matchenconfig.hotDraws')) {
        this.set('hotDraws', svs.matchen.data.matchenconfig.hotDraws, {
          silent: true
        });
      }

      if (
        svs.utils.ns.isNamespace('svs.matchen.data.matchenconfig.startPageConfig.tabs')
      ) {
        this.set('tabs', svs.matchen.data.matchenconfig.startPageConfig.tabs, {
          silent: true
        });
      }

      if (
        svs.utils.ns.isNamespace('svs.matchen.data.matchenconfig.startPageConfig.links')
      ) {
        this.set(
          'links',
          svs.matchen.data.matchenconfig.startPageConfig.links,
          { silent: true }
        );
      }

      if (svs.utils.ns.isNamespace('svs.matchen.data.matchenconfig.hotDraws')) {
        this.set('hotDraws', svs.matchen.data.matchenconfig.hotDraws, {
          silent: true
        });
      }

      if (
        svs.utils.ns.isNamespace('svs.matchen.data.matchenconfig.startPageConfig.promo.startPageBackground.url')
      ) {
        this.set(
          'backgroundImageURL',
          svs.matchen.data.matchenconfig.startPageConfig.promo
            .startPageBackground,
          { silent: true }
        );
      }

      hasNoOpenDrawsTxt = svs.utils.ns.isNamespace('svs.matchen.data.matchenconfig.startPageConfig.promo.startPageBackgroundText.NoOpenDrawsInfo');
      if (
        hasNoOpenDrawsTxt &&
        svs.matchen.data.matchenconfig.startPageConfig.promo
          .startPageBackgroundText.NoOpenDrawsInfo != ''
      ) {
        this.set(
          'noOpenDrawsTxt',
          svs.matchen.data.matchenconfig.startPageConfig.promo
            .startPageBackgroundText.NoOpenDrawsInfo,
          { silent: true }
        );
      }
    },

    setSport: function(sportType) {
      var heatmapLimit = _.findWhere(
        svs.matchen.data.matchenconfig.heatmapLimits,
        { type: sportType }
      );
      heatmapLimit = heatmapLimit ?
        heatmapLimit :
        _.findWhere(svs.matchen.data.matchenconfig.heatmapLimits, {
          type: this.TYPE_SOCCER
        });

      if (heatmapLimit) {
        this.set('heatmapLimit', heatmapLimit);
      }
    },

    getMinOutcomeValue: function() {
      return this.get('heatmapLimit').min;
    },

    getMaxOutcomeValue: function() {
      return this.get('heatmapLimit').max;
    },

    getHeatmapStartMin: function() {
      return this.get('heatmapLimit').startMin;
    },

    getHeatmapStartMax: function() {
      return this.get('heatmapLimit').startMax;
    },

    getHotDraws: function() {
      return this.get('hotDraws');
    },

    getTabs: function() {
      return this.get('tabs');
    },

    getLinks: function() {
      return this.get('links');
    },

    getBackgroundImageURL: function() {
      return this.get('backgroundImageURL');
    },

    getNoOpenDrawsTxt: function() {
      return this.get('noOpenDrawsTxt');
    }
  });
})(Backbone, _, svs);


 })(window);